import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/checkout';

/** Appears once the visitor scrolls past the first hero CTA. */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    if (!target) return;
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-159" data-mp="38b8nm837wooy">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-160" data-mp="38ca1ekbmbpad">
          <div className="mx-auto w-full max-w-md" data-id="element-161" data-mp="3329g2i1kd7x7">
            <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-gold-300 bg-gold-500 px-4 py-3.5 text-center text-[14px] font-extrabold uppercase tracking-tight text-navy-900 shadow-lift transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy-900 sm:text-base" data-id="element-162" data-mp="2pce91pma4vm4">
              Get Occlusion 360™ — $27
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-163" data-mp="2behbor004l6e" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}